import { Component, ViewChild, ViewContainerRef } from '@angular/core';
import { RouterLink, RouterOutlet } from '@angular/router';
import { PRIME_LOCALE_ES } from './core/constants/prime.local.constants';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { PrimeNGConfig } from 'primeng/api';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { Toast, ToastCloseEvent, ToastModule } from 'primeng/toast';
import { map, Observable } from 'rxjs';
import { AppConstants } from './core/constants/app.constants';
import { ToastService } from './core/services/toast.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    ButtonModule,
    CommonModule,
    RouterLink,
    RouterOutlet,
    ToastModule,
    TranslateModule,
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  @ViewChild('global') toast: Toast;
  @ViewChild('global', { read: ViewContainerRef, static: true }) toastRef: ViewContainerRef;
 
  @ViewChild('custom') customToast: Toast;
  @ViewChild('custom', { read: ViewContainerRef, static: true }) customToastRef: ViewContainerRef;

  private primeLocalEs: any;
  public showToastOverlay: boolean;
  public index: number;
  public traceVisibleSet: Set<string>;

  constructor(
    private readonly config: PrimeNGConfig,
    private readonly toastservice: ToastService,
    private readonly translateService: TranslateService
  ) {
    this.primeLocalEs = PRIME_LOCALE_ES;
    this.showToastOverlay = true;
    this.index = AppConstants.TOAST_INDEX;
    this.traceVisibleSet = new Set<string>();
    this.initializeDefaultLanguage();
  }

  public ngOnInit(): void {
    this.getOverlayState();
  }

  /**
   * @description Initialize default language in system.
   * @return {void}
   */
  private initializeDefaultLanguage(): void {
    this.translateService.setDefaultLang('es');
    this.config.setTranslation(this.primeLocalEs);
  }

  public getTranslatedSize(key: string): Observable<number> {
    return this.translateService.get(key).pipe(
      map((translation: string) => {
        const cleanedMessage = translation.trim().replace(/\s+/g, ' ');
        return cleanedMessage.length;
      })
    );
  }

  public handleActionInToast(event: any): void {
    this.customToast.messages = this.customToast.messages.filter(
      (message) => message.data.unique !== event.data.unique
    );
    this.toastservice.closeToast();
  }

  /**
   * @description Close toast information
   * @return {void}
   */
  public onClose(event: ToastCloseEvent): void {
    this.toast.messages = this.toast.messages.filter(
      (message) => message.data.unique !== event.message.data.unique
    );
    this.toastservice.closeToast();
  }

  public toggleTraceId(traceId: string): void {
    if (this.traceVisibleSet.has(traceId)) {
      this.traceVisibleSet.delete(traceId);
    } else {
      this.traceVisibleSet.add(traceId);
    }
  }

  public isTraceVisible(traceId: string): boolean {
    return this.traceVisibleSet.has(traceId);
  }

  /**
   * @description Get status to show or hide overlay
   * @return {void}
   */
  private getOverlayState(): void {
    this.toastservice.overlay$.subscribe(visible => {
      this.showToastOverlay = visible;
    });
  }
}
